import React, { FunctionComponent } from 'react'

import { OverviewCard as Card } from './style'

export const OverviewCard: FunctionComponent = (props) => {
    return <Card>{props.children}</Card>
}
